import crossroadsImport from 'crossroads/dist/crossroads.js';

/** Unwrap CJS default interop so addRoute/parse work under ESM namespace imports. */
const crossroads = ((crossroadsImport as {default?: typeof crossroadsImport}).default ??
    crossroadsImport);

export {crossroads};
export default crossroads;
